// NEW: UI_REVAMP
import { Flex, Image, Text } from '@chakra-ui/react';
import Lottie from 'lottie-react';
import failedGif from '../../assets/gif/failed.gif';
import betSuccessful from '../../lottie/betSuccessful.json';
import GoldPatternButton from '../button/GoldPatternButton';

export const BetStatus = ({ status, amount, onClick, buttonText }) => {
	const isSuccess = status === 'success';
	return (
		<Flex flexDirection='column' w='100%' h='full' overflowY='auto'>
			{isSuccess ? (
				<Lottie
					animationData={betSuccessful}
					loop
					renderer='svg'
					className='mx-auto'
					style={{
						width: '340px',
						alignSelf: 'center',
					}}
				/>
			) : (
				<Image src={failedGif} alt='failed' mx='auto' w='200px' h='200px' />
			)}
			<Text textAlign='center' fontWeight='500' fontSize='24px' textTransform='capitalize'>
				Bet {isSuccess ? 'Successful' : 'Failed'}
			</Text>

			{isSuccess ? (
				<Text textAlign='center' fontWeight='800' fontSize='36px'>
					PHP {amount}
				</Text>
			) : (
				<Text textAlign='center' fontWeight='500' fontSize='20px'>
					Please try again later
				</Text>
			)}

			<Flex justifyItems='center' my={4} maxW='340px' w='100%' placeSelf='center'>
				<GoldPatternButton onClick={onClick}>{buttonText}</GoldPatternButton>
			</Flex>
		</Flex>
	);
};
